import React from 'react';
import PropTypes from 'prop-types';
import './Attributes.css';

const Attributes = ({ attributes }) => {
  if (!attributes || attributes.length === 0) {
    return <p>No attributes available.</p>;
  }

  return (
    <div className="attributes-container">
      <h4>Attributes</h4>
      <ul className="attributes-list">
        {attributes.map((attribute, index) => (
          <li key={index} className="attribute-item">
            <strong>{attribute.attributeName || attribute.name}:</strong> {attribute.attributeValue || attribute.value}
          </li>
        ))}
      </ul>
    </div>
  );
};

Attributes.propTypes = {
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      attributeName: PropTypes.string,
      attributeValue: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

export default Attributes;
